/* Klay Route presentation only. No cart requests, checkout handlers,
   protection selection, prices, tracking or app settings are modified. */
(() => {
  'use strict';
  if (window.__klayRouteCoverageDisplay) return;
  window.__klayRouteCoverageDisplay = true;

  const options = { childList: true, subtree: true, characterData: true };
  let frame = 0;
  const observer = new MutationObserver(schedule);

  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }

  function sync() {
    frame = 0;
    observer.disconnect();
    try {
      document.querySelectorAll('button[data-route-cloned-button]').forEach(button => {
        const widget = button.closest('[data-route-widget]');
        const parent = button.parentElement;
        const price = button.querySelector('.route-premium-text-stacked');
        const details = widget && widget.querySelector('.pw-cashback-see-details');
        const optOut = parent && parent.querySelector('.route-continue-without-coverage-link');
        if (!widget || !parent || !price || !details || !optOut) return;

        // Read Route's formatted price; never calculate or hard-code it.
        const raw = price.textContent.trim();
        if (!/Package Protection\s*$/i.test(raw)) return;
        const amount = raw.replace(/\s*Package Protection\s*$/i, '').trim();
        if (!amount || !/\d/.test(amount)) return;

        let help = Array.from(parent.children).find(
          element => element.classList.contains('ktl-route-coverage')
        );
        if (!help) {
          help = document.createElement('p');
          help.className = 'ktl-route-coverage';
          const text = document.createElement('span');
          text.className = 'ktl-route-coverage__text';
          const info = document.createElement('button');
          info.type = 'button';
          info.className = 'ktl-route-coverage__info';
          info.textContent = '?';
          info.setAttribute('aria-label', 'Read Route package protection coverage details');
          info.setAttribute('aria-haspopup', 'dialog');
          info.setAttribute('aria-controls', 'rm-modal-container');
          info.addEventListener('click', () => {
            // Use Route's existing details handler, including after a rerender.
            const current = widget.querySelector('.pw-cashback-see-details');
            if (current) current.click();
          });
          help.append(text, info);
          parent.appendChild(help);
        }
        const sentence = `${amount} for coverage on lost, damaged, or stolen orders.`;
        const text = help.querySelector('.ktl-route-coverage__text');
        if (text.textContent !== sentence) text.textContent = sentence;
        widget.classList.add('ktl-route-ready');
      });
    } finally {
      observer.observe(document.body, options);
    }
  }

  if (document.body) sync();
  else document.addEventListener('DOMContentLoaded', sync, { once: true });
})();
